import { CustomTheme } from '../../../hooks/theme-hook';

export interface FilterPanelTokens {
  resetFiltersLabel: string;
  triggerBackgroundColor: string;
  triggerTextColor: string;
  triggerBorderColor: string;
  panelBackgroundColor: string;
  panelBorderColor: string;
  businessTypeBackgroundColor: string;
  businessTypeTitleColor: string;
  textColor: string;
  switchCardTextColor: string;
  switchCardBorderColor: string;
  activePillBackgroundColor: string;
  activePillTextColor: string;
  inactivePillBorderColor: string;
}

export const getFilterPanelTokens = (theme: CustomTheme, uiLanguage?: string | null): FilterPanelTokens => ({
  resetFiltersLabel: uiLanguage?.toLowerCase()?.startsWith('fr') ? 'Réinitialiser' : 'Reset',
  triggerBackgroundColor: theme.background.primary.toString(),
  triggerTextColor: theme.text.darkTurquoiseTwo.toString(),
  triggerBorderColor: theme.borderColorLight?.toString() ?? '#d7e3ec',
  panelBackgroundColor: theme.background.primaryLight.toString(),
  panelBorderColor: theme.borderColorLight?.toString() ?? '#d7e3ec',
  businessTypeBackgroundColor: theme.background.modal.toString(),
  businessTypeTitleColor: theme.text.darkTurquoiseTwo.toString(),
  textColor: theme.text.primary.toString(),
  switchCardTextColor: theme.text.primary.toString(),
  switchCardBorderColor: theme.isDark ? '#5f7486' : '#d7e3ec',
  activePillBackgroundColor: '#d9eef8',
  activePillTextColor: '#000000',
  inactivePillBorderColor: '#c5cfdb',
});
